import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const box: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: (p) => p.palette.common.white,
  borderRadius: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(0.5),
  cursor: 'pointer',
};
